module.exports = __webpack_public_path__ + "img/day1.e7dd950b.jpeg";